export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwoEars_rg_p.b4e99cfd.jpg";